import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import './CustomSection.scss';


const CustomSection = ({ children, className }) => (
  <section
    className={classNames(
      'custom-section',
      className,
    )}
  >
    <div className="custom-section__container container">
      {children}
    </div>
  </section>
);

CustomSection.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

CustomSection.defaultProps = {
  children: undefined,
  className: undefined,
};

export default CustomSection;
